export default "__VITE_ASSET__B41OaC_M__"